import constants from "../constants";

function setAuthData(data) {
  // console.log("data.currentUser", data.currentUser);
  return function (dispatch) {
    dispatch({
      type: constants.SET_AUTH_DATA,
      payload: {
        currentUser: data.currentUser,
        token: data.token,
      },
    });
  };
}
function setBetPlaced(data) {
  return function (dispatch) {
    dispatch({
      type: constants.SET_BET_PLACED,
      payload: {
        betPlaced: data.betPlaced,
      },
    });
  };
}
function setCashedOut(data) {
  return function (dispatch) {
    dispatch({
      type: constants.SET_CASHED_OUT,
      payload: {
        cashedOut: data.cashedOut,
      },
    });
  };
}
export { setAuthData, setBetPlaced,setCashedOut };
